import { useState } from "react";
import SurveyIngestion from "@solimat/solimat-web-endpoint/lib/survey-ingestion";
import { GastarOportunidadRequest } from "@solimat/solimat-web-endpoint/lib/survey-ingestion/dto";

const useGastarOportunidad = () => {
  const BASE_URL = import.meta.env.VITE_REACT_APP_ENCUESTAS_PATH || "";
  const FUNCTIONS_KEY = import.meta.env.VITE_REACT_APP_ENCUESTAS_KEY || "";
  const apiSurvey = new SurveyIngestion.SurveyIngestionService(BASE_URL, FUNCTIONS_KEY);

  const [loadingGastarOportunidad, setLoadingGastarOportunidad] = useState(false);
  const [successGastarOportunidad, setSuccessGastarOportunidad] = useState(false);
  const [errorGastarOportunidad, setErrorGastarOportunidad] = useState(null);
  const [asignacionEncuestaId, setAsignacionEncuestaId] = useState<string>(null);

  const gastarOportunidad = async (data: GastarOportunidadRequest) => {
    setLoadingGastarOportunidad(true);
    setErrorGastarOportunidad(null);
    try {
      const res = await apiSurvey.gastarOportunidad(data);
      setSuccessGastarOportunidad(true);
      setLoadingGastarOportunidad(false);
      setAsignacionEncuestaId(res.data as string)
      return res.data as string;
    }
    catch(err) {
      console.error("gastarOportunidad error: ", err);
      setErrorGastarOportunidad(err);
      setLoadingGastarOportunidad(false);
    }
  };

  return {
    asignacionEncuestaId,
    gastarOportunidad,
    successGastarOportunidad,
    loadingGastarOportunidad,
    errorGastarOportunidad
  };
};

export default useGastarOportunidad;